import { FEDERATED_APP_SETTINGS } from 'common/constants/constants';
import { loadRemoteApp, resolveRemoteUrl } from 'common/utils/moduleFederation';
import ErrorBoundary from 'components/ErrorBoundary';
import { CenterLoader } from 'connected-components/Loader/Loader';
import { ComponentType, Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { prevIterationSelector } from 'state/selectors/iterations-picker';
import { organizationSelector } from 'state/selectors/organization';
import {
  selectedTeamWithExtraDataSelector,
  teamsFlatTreeSelector
} from 'state/selectors/teams';
import { repositoriesSelector } from 'state/selectors/repositories';
import {
  dateRangeSelector,
  selectedPeriodKeySelector
} from 'state/selectors/ui-state';
import { getSensorAuthorizations } from 'state/selectors/sensors-authorizations';

const app = FEDERATED_APP_SETTINGS.PRODUCTIVITY;

const url = resolveRemoteUrl(process.env.NODE_ENV, window.location, app, true);

const ProductivityApp = lazy<ComponentType<any>>(loadRemoteApp(url, app));

export function Productivity() {
  const dateRange = useSelector(dateRangeSelector);
  const currentTeam = useSelector(selectedTeamWithExtraDataSelector)?.[0];
  const allTeams = useSelector(teamsFlatTreeSelector);
  const selectedPeriodKey = useSelector(selectedPeriodKeySelector);
  const prevIteration = useSelector(prevIterationSelector);
  const organization = useSelector(organizationSelector);
  const account = useSelector(myAccountSelector);
  const sensorAuthorizations = useSelector(getSensorAuthorizations);
  const repositories = useSelector(repositoriesSelector);

  return (
    <ErrorBoundary>
      <Suspense fallback={<CenterLoader />}>
        <ProductivityApp
          dateRange={dateRange}
          currentTeam={currentTeam}
          allTeams={allTeams}
          selectedPeriodKey={selectedPeriodKey}
          prevIteration={prevIteration}
          organization={organization}
          account={account}
          sensorAuthorizations={sensorAuthorizations}
          repositories={repositories}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
